import useInterval from '@dyl/hooks/useInterval';
import { isEqual } from 'lodash';
import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import ConnectingLinesContext from './context';

export default React.forwardRef(
    function ConnectingLinesNode({
        lineId,
        side,
        component: Node = 'div',
        ...other
    }, ref) {
        /** @type {import('react').MutableRefObject<HTMLDivElement} */
        const internalRef = useRef();
        ref = ref || internalRef;

        const { registerNode } = useContext(ConnectingLinesContext);

        const [position, setPosition] = useState({ x: 0, y: 0 });

        useInterval(0, () => {
            const rect = ref.current.getBoundingClientRect();
            const position = {
                x: rect.x + window.scrollX + rect.width / 2,
                y: rect.y + window.scrollY + rect.height / 2,
            };

            setPosition(prev => {
                return isEqual(prev, position) ? prev : position;
            });
        }, []);

        useLayoutEffect(() => {
            const unregister = registerNode({
                lineId,
                side,
                position,
            });

            return () => unregister();
        }, [lineId, side, position])

        return <Node ref={ref} {...other} />;
    }
);